export interface PastProvider {
    first_name: string;
    last_name: string;
    id: number;
    babysitter_id: number;
}

export const emptyProvider = { first_name: '', last_name: '', babysitter_id: -1, id: -1 };
